import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAuth, getUser } from '../utils/auth';
import DashboardLayout from '../components/DashboardLayout';
import DashboardActionCard, { BookmarkIcon } from '../components/DashboardActionCard';

const RecruiterHome = () => {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    clearAuth();
    navigate('/');
  };

  return (
    <DashboardLayout
      eyebrow="RECRUITER DASHBOARD"
      heading="Welcome back"
      subtitle="Browse and filter every job your team has saved to the database."
      email={user?.email}
      onLogout={handleLogout}
    >
      <DashboardActionCard
        to="/recruiter/jobs"
        icon={<BookmarkIcon />}
        iconBg="rgba(22, 50, 79, 0.08)"
        title="View Saved Jobs"
        description="Browse, filter and revisit every job your team has already saved to the database."
      />
    </DashboardLayout>
  );
};

export default RecruiterHome;
